import React, { useEffect, useState } from "react";
import { NotificationSummary } from "../../components";
import { NOTIFICATION_TYPE } from "../../types/enumerations/notifications";
var SiteAlertSummary = function (_a) {
    var countData = _a.countData;
    var _b = useState([]), subData = _b[0], setSubData = _b[1];
    var _c = useState({}), mainData = _c[0], setMainData = _c[1];
    useEffect(function () {
        var upcomingCount = 0, etaMissedCount = 0, openCount = 0, closedCount = 0;
        (countData || []).forEach(function (countItem) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (((_a = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === "IN-PROGRESS") {
                openCount += ((_b = countItem === null || countItem === void 0 ? void 0 : countItem.count) !== null && _b !== void 0 ? _b : 0);
            }
            else if (((_c = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === "ETA MISSED") {
                etaMissedCount += ((_d = countItem === null || countItem === void 0 ? void 0 : countItem.count) !== null && _d !== void 0 ? _d : 0);
            }
            else if (((_e = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === "RESOLVED") {
                closedCount += ((_f = countItem === null || countItem === void 0 ? void 0 : countItem.count) !== null && _f !== void 0 ? _f : 0);
            }
            else if (((_g = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === "UPCOMING") {
                upcomingCount += ((_h = countItem === null || countItem === void 0 ? void 0 : countItem.count) !== null && _h !== void 0 ? _h : 0);
            }
        });
        var mainDataObj = { title: "Open", value: openCount };
        var subDataArray = [{ title: "Upcoming", value: upcomingCount }, { title: "ETA missed", value: etaMissedCount }, { title: "Closed", value: closedCount }];
        setSubData(subDataArray);
        setMainData(mainDataObj);
    }, [countData]);
    return React.createElement(NotificationSummary, { notificationType: NOTIFICATION_TYPE.SITE_ALERTS, subData: subData, mainData: mainData });
};
export default SiteAlertSummary;
//# sourceMappingURL=index.js.map